exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date_range > input {\n  padding-bottom: 5px !important;\n  margin-bottom: 3px;\n}\n", ""]);

// exports
